<template>
  <div>
    <!--    ===================================================================================================-->
    <!--    ===================================================================================================-->
    <h3 style="color: white">
      {{ $t("client representative info") }}
    </h3>
    <div>
      <div class="row">
        <div
          class="col-xs-12"
          v-for="(rep, rep_index) in user_profile.userRepresentatives"
        >
          <RepBlock
            :key="`resp-${rep_index}`"
            form_data_key="representative"
            :form_data_index="rep_index"
            :form_data="rep"
            :form_data_list="user_profile.userRepresentatives"
            :minimize="true"
            :user_profile="user_profile"
            @deleted="
              value => user_profile.userRepresentatives.splice(value, 1)
            "
          ></RepBlock>
        </div>
        <div
          class="col-xs-12"
          v-if="!(user_profile.userRepresentatives.length > 0)"
        >
          <div class="rep_minimize">
            <p class="rep_title">
              {{ $t("empty list") }}
            </p>
          </div>
        </div>

        <router-link
          :to="{
            name: 'representatives-form',
            params: { rep_type: 'representative' }
          }"
          tag="div"
          class="col-xs-12"
        >
          <div class="pane-list-add" style="float: left !important;">
            <br />
            <p>
              {{ $t("add") }} <b>{{ $t("info").toLowerCase() }}</b>
            </p>
          </div>
        </router-link>
        <div v-if="user_profile.userRepresentatives.length > 0">
          <br />
          <file-input
            :mini="true"
            :is_uploaded="form_files.representative_power"
            v-model="form_files.representative_power"
            @attached="
              saveFile(form_files.representative_power, 'representative_power')
            "
            class="form__input-container"
            componentID="doc_1"
          >
            {{ $t("le body proxy / decision") }}
          </file-input>
          <file-input
            :mini="true"
            :is_uploaded="form_files.representative_id"
            v-model="form_files.representative_id"
            @attached="
              saveFile(form_files.representative_id, 'representative_id')
            "
            class="form__input-container"
            componentID="doc_2"
          >
            {{ $t("le representative / head/ office id") }}
          </file-input>
        </div>
      </div>
    </div>
    <hr class="horizontal-line" />

    <!--    ===================================================================================================-->
    <!--    ===================================================================================================-->
    <h3 style="color: white">
      {{ $t("client third party info") }}
    </h3>
    <div>
      <div class="row" v-if="beneficiars.length > 0">
        <div
          class="col-xs-12"
          v-for="(rep, rep_index) in beneficiars"
          :key="`resp-${rep_index}`"
        >
          <RepBlock
            form_data_key="beneficiar"
            :form_data_index="rep_index"
            :form_data="rep"
            :form_data_list="beneficiars"
            :minimize="true"
            :user_profile="user_profile"
            @deleted="beneficiars = []"
          ></RepBlock>
        </div>
        <div class="col-xs-12">
          <div v-if="isUserLegal">
            <br />
            <file-input
              :mini="true"
              :is_uploaded="form_files.beneficiary_id"
              v-model="form_files.beneficiary_id"
              @attached="saveFile(form_files.beneficiary_id, 'beneficiary_id')"
              class="form__input-container"
              componentID="doc_3"
            >
              {{ $t("beneficial le id") }}
            </file-input>
          </div>
        </div>
      </div>
      <div class="row" v-else>
        <router-link
          :to="{
            name: 'representatives-form',
            params: { rep_type: 'beneificiar' }
          }"
          tag="div"
          class="col-xs-12"
        >
          <div class="pane-list-add" style="float: left !important;">
            <br />
            <p>
              {{ $t("add") }} <b>{{ $t("info").toLowerCase() }}</b>
            </p>
          </div>
        </router-link>
      </div>
    </div>
    <button @click="goNext" class="button form__button">
      {{ $t("continue") }}
    </button>
  </div>
</template>

<script>
import RepBlock from "./03_2_RepresentativeBlockForm";
import RegFormMixin from "../form_mixin";

export default {
  props: ["user_profile"],
  components: {
    RepBlock
  },
  data() {
    return {
      beneficiars: [],
      form_files: {
        representative_power: null,
        representative_id: null,
        beneficiary_id: null
      }
    };
  },
  mixins: [RegFormMixin],
  computed: {},
  watch: {
    user_profile: function(value) {
      this.fetchData();
    }
  },
  methods: {
    fetchData() {
      if (this.user_profile.userBeneficiar != null) {
        this.beneficiars = [this.user_profile.userBeneficiar];
      }
      Object.entries(this.form_files).map(obj => {
        let find_file = this.user_profile.userUploadedDocuments.find(
          file => file.type === obj[0]
        );
        // console.log(this.form_files);
        this.form_files[obj[0]] = (find_file ? true : null) || null;
      });
    },
    goToEdit(index, type) {
      this.$router.push({
        name: "representatives-form-edit",
        params: {
          rep_type: type,
          rep_index: index
        }
      });
    },
    benDeleted() {},
    goNext() {
      if (this.isUserLegal) {
        // if (
        //   this.form_files.representative_power &&
        //   this.form_files.representative_id &&
        //   this.form_files.beneficiary_id
        // ) {
        //
        // } else {
        //   this.$toasted.show("Приложите файлы");
        // }
        this.$router.push({
          name: "legal-branches"
        });
      } else {
        this.$router.push({ name: "address-info" });
      }
    }
  },
  beforeMount() {
    this.fetchData();
  }
};
</script>
